<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0"> Select Attachment Files </h5>
      <br />
      <br />



      <div class="table-responsive" >
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Letter Number</th>
              <th>Customer Name</th>
              <th>File</th>
              <th>Status</th>
              <th>Actions</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Schedules">
              <td>{{DataList_Schedules.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.dsc}}</td>
              <td>
                <a target="_blank"  href="{{BaseUrl}}File/Letter/{{item.code}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
              </td>
              <td>
                <p *ngIf="item.del" style="color: #489b39;">Selected</p>
                <p *ngIf="!item.del" style="color: crimson;">Not Selected</p>
              </td>
              <td>
                <button *ngIf="!item.del" (click)="AddFilePeyvastActivity(item)" type="button" class="btn btn-success"> Select </button>
                <button *ngIf="item.del" (click)="RemoveFilePeyvastActivity(item)" type="button" class="btn btn-danger"> Deselect </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
